<!-- 头部 -->
<template>
  <div class="header">
    <div class="header-top">
      <div class="header-left">
        <h2
          style="font-family:'SourceHanSansCN-Regular';font-size:25px;color:#00467F;font-weight:regular;"
        >波士顿科学肿瘤介入专业教育中心</h2>
      </div>
      <div class="header-right">
        <div>
          <span style="background-color: white;color:rgba(102, 102, 102, 0.9);">
            <span style="cursor: pointer;" @click="login" v-if="!userInfo.RealName">注册 | 登录</span>
            <div v-else style="display:flex;justify-content: flex-end;">
              <span style="color:#00477F">{{userInfo.RealName}}</span>
              <span style="cursor: pointer;" @click="loginOut">| 登出</span>
            </div>
            <span
              style="font-size:15px;background-color: white;color:rgba(102, 102, 102, 0.8);"
            >本网站仅供医疗专业人士参考</span>
          </span>
        </div>
      </div>
    </div>
    <div :class="{'header-box':true,'is-fixed':isFixed}">
      <ul class="header-inner">
        <li v-for="(item,index) in menuList" :key="index" class="item">
          <div
            :class="{active:activeIndex==item.key}"
            style="height:50px;display: flex;align-items: center;padding-left:3px;"
            v-if="item.key==='home'"
            @click="handleSelect(1,item)"
          >
            <img :src="'./static/img/home/active-home.svg'" v-if="activeIndex=='home'" />
            <img :src="'./static/img/home/EDUCARE.svg'" v-else />
          </div>
          <span
            v-else
            @click="handleSelect(1,item)"
            :class="{active:activeIndex==item.key}"
          >{{item.name}}</span>
          <ul v-if="item.child" class="child">
            <li
              v-for="(i,j) in item.child"
              :key="j"
              class="child-li"
              @click="handleSelect(2,item,i)"
            >
              <span>{{i.name}}</span>
              <i class="el-icon-arrow-right" v-if="i.child"></i>
              <ul v-if="i.child" class="child-child">
                <li
                  v-for="(_i,_j) in i.child"
                  :key="_j"
                  class="child-li"
                  @click="handleSelect(3,item,_i)"
                >{{_i.name}}</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div style="height:50px" v-if="isFixed"></div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import { backTop } from '@/utils/util'
import { getUser } from '@/api/index'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
const FIXHEIGHT = 75
export default {
  name: 'g-header',
  data() {
    return {
      activeIndex: 'home',
      isFixed: false,
      userInfo: {}
    }
  },
  computed: {
    ...mapGetters(['pageData']),
    dataSource() {
      return this.pageData['mainMenu']
    },
    menuList() {
      return this.pageData['menuList']
    }
  },
  methods: {
    getUserInfo() {
      const href = window.location.href
      if (href.includes('access_token')) {
        const token = href.split('access_token=')[1].split('&')[0]
        getUser(token).then((res) => {
          const result = JSON.parse(res.data)
          if (result.RealName && result.RealName !== '') {
            setToken(token)
            Cookies.set('userinfo', result)
            this.userInfo = result
            this.$gtag.set({
              user_id: this.userInfo['RealName'] + '__' + this.userInfo['ID']
            })
          } else if (result.ErrorMessage) {
            Message.warning('系统错误，请稍后再试。')
          }
        })
      } else if (
        getToken() !== 'undefined' &&
        getToken() !== '' &&
        Cookies.get('userinfo')
      ) {
        const info = JSON.parse(Cookies.get('userinfo'))
        if (info.RealName != '') {
          setToken(getToken())
          Cookies.set('userinfo', info)
          this.userInfo = info
          this.$gtag.set({
            user_id: this.userInfo['RealName'] + '__' + this.userInfo['ID']
          })
        }
      }
    },
    loginOut() {
      Cookies.remove('redirect_url')
      Cookies.remove('userinfo')
      removeToken()
      window.location.href =
        window.location.protocol + '//' + window.location.host
    },
    login() {
      var param = window.location.href.substring(
        window.location.href.indexOf('#') + 1
      )
      param = param.split('access_token')[0]
      param = param.replace('//', '/')
      Cookies.set('redirect_url', param)
      window.location.href =
        'https://passport.bscwin.com/AuthUser/CheckUser?client_id=35&redirect_uri=http%3a%2f%2fio.bostonscientific.cn%2fredirect.html'
    },
    handleSelect(index, item, val) {
      this.$message.closeAll()
      if (
        [
          'therapy',
          'interventionalVoice',
          'centre',
          'home',
          'patientEducation'
        ].includes(item.key)
      ) {
        const route = {}
        route['name'] = index == 1 ? item.key : val.routeName
        if (val && val.query) {
          route['query'] = val.query
        }
        if (
          (index == 1 && !item.child) ||
          (index == 2 && !val.child) ||
          index == 3
        ) {
          this.$router.push(route)
        }
        this.$nextTick(() => {
          if (this.activeIndex !== this.$route.meta.main) {
            backTop(this)
          }
          this.activeIndex = this.$route.meta.main
        })
      } else if (item.key == '8') {
        window.open('http://www.bostonscientific.cn/Institute')
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.isFixed = scrollTop > FIXHEIGHT
    }
  },
  mounted() {
    this.activeIndex = this.$route.meta.main
    window.addEventListener('scroll', this.handleScroll, true)
    this.getUserInfo()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang='less' scoped>
.home-img {
  margin-top: 5px;
}
@head-top: 74.8px;
@head-menu: 50px;
.header {
  // font-family: 'SourceHanSansCN-Regular';
  background-color: #fff;
  .header-top {
    height: @head-top;
    max-width: 1400px;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > img {
      .wh(345px, 36px);
    }
    > h2 {
      float: left;
    }
    .header-right {
      > div {
        display: flex;
        align-items: center;
        text-align: right;
        > span {
          padding: 7.9px 27.7px 7.9px 23.6px;
          background-color: @theme-blue;
          color: #fff;
          font-size: 17px;
          line-height: 25px;
        }
        > img {
          .wh(17px, 19px);
          margin-left: 18.2px;
        }
      }
      > h2 {
        font-size: 14px;
        color: #768088;
        // width: 160px;
        text-align: center;
        margin-top: 4px;
        font-family: 'SourceHanSansCN-Regular';
      }
    }
  }
  .header-box {
    width: 100%;
    border-top: 1px solid rgb(211, 211, 211);
    z-index: 1000;
    background-color: #fff;
    font-family: 'SourceHanSansCN-Regular';
    .header-inner {
      max-width: 1360px;
      margin: 0 auto;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      // .header-item {
      //   font-size: 20px;
      //   .wh(140px, @head-menu);
      //   text-align: center;
      //   line-height: 50px;
      //   color: #666666;
      // }
      // .header-item:hover {
      //   background-color: rgb(240, 240, 240);
      //   color: #333;
      // }
      // .header-item:active {
      //   background-color: @theme-blue;
      //   color: #fff;
      // }
      .active {
        background-color: @theme-blue !important;
        color: #fff !important;
      }
    }
  }
  .is-fixed {
    position: fixed;
    border-bottom: 1px solid rgb(211, 211, 211);
    left: 0px;
    top: 0;
    // top: -@head-menu;
    // transform: translateY(@head-menu);
    // transition: all 1.5s;
  }
}
span {
  display: block;
}
.header-inner {
  .item {
    font-size: 20px;
    .wh(140px, @head-menu);
    text-align: center;
    line-height: 50px;
    color: #666666;
    position: relative;
    .child {
      font-size: 18px;
      display: none;
      z-index: 1000;
      position: absolute;
      top: @head-menu;
      left: 0;
      width: 310px;
      background-color: #fff;
      border-right: 2px solid #ccc;
      .child-child {
        position: absolute;
        z-index: 1000;
        height: 100%;
        width: 270px;
        top: 0px;
        left: 310px;
        display: none;
        background-color: #fff;
        color: #666666;
      }
    }
    .child-li {
      padding: 0 10px;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:hover {
        background-color: #00477f;
        color: #fff;
      }
    }
  }
  .item:hover .child {
    display: block;
  }
  .child-li:hover .child-child {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gHeader.vue